import { useEffect, useState } from 'react'
import { useI18n } from '../lib/i18n'

// EUDR application deadline countdown — a genuinely live readout (ticks every
// second), so the looping LIVE dot + updating digits are permitted (DESIGN.md §6).
const TARGET = Date.parse('2026-12-30T00:00:00+07:00')
const pad = (n: number) => String(n).padStart(2, '0')

function remaining() {
  const ms = Math.max(0, TARGET - Date.now())
  return {
    d: Math.floor(ms / 86_400_000),
    h: Math.floor((ms % 86_400_000) / 3_600_000),
    m: Math.floor((ms % 3_600_000) / 60_000),
    s: Math.floor((ms % 60_000) / 1000),
  }
}

export function Countdown() {
  const { lang } = useI18n()
  const [t, setT] = useState(remaining)
  useEffect(() => {
    const id = setInterval(() => setT(remaining()), 1000)
    return () => clearInterval(id)
  }, [])

  const C = lang === 'vi'
    ? { label: 'EUDR ÁP DỤNG TỪ 30/12/2026, CÒN LẠI', u: ['ngày', 'giờ', 'phút', 'giây'] }
    : { label: 'EUDR APPLIES FROM 30/12/2026 · TIME LEFT', u: ['days', 'hrs', 'min', 'sec'] }

  const units = [
    { v: String(t.d), u: C.u[0] },
    { v: pad(t.h), u: C.u[1] },
    { v: pad(t.m), u: C.u[2] },
    { v: pad(t.s), u: C.u[3] },
  ]

  return (
    <div className="countdown" role="timer" aria-live="off">
      <div className="countdown-head">
        <span className="live-dot countdown-dot" aria-hidden />
        <span className="countdown-label">{C.label}</span>
      </div>
      <div className="countdown-units">
        {units.map((x, i) => (
          <div className="countdown-unit" key={i}>
            <span className="countdown-n mono">{x.v}</span>
            <span className="countdown-u mono">{x.u}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
